export const sectionConfig = {
  "suptitle": "برترین هوش مصنوعی ایران",
  "title": "هوش مصنوعی فیگ ای آی",
  "caption": "با فیگ ای آی میتوانید به برترین هوش مصنوعی های بین المللی دسترسی داشته باشید و قابلیت هایی که هیچ جایی ندیدید را با آنها ترکیب کنید. ",
  "start_button": {
    "label": "تهیه اشتراک",
    "link": "https://pay.figai.ir?utm_source=landing&utm_medium=button&utm_term=hero_purchase_subscription"
  },
  "secondary_button": {
    "label": "ورود به اپ",
    "link": "https://webui.figai.ir"
  },
}

export type SectionConfig = typeof sectionConfig
